var map = {
	"./charity/en.json": [
		"d692",
		"chunk-2d21e7e1"
	],
	"./charity/ru.json": [
		"fc51",
		"chunk-2d23790f"
	],
	"./charity/uz-to1.json": [
		"c8f8",
		"chunk-2d21807d"
	],
	"./charity/uz.json": [
		"1b48",
		"chunk-2d0b5d8b"
	],
	"./happiness/en.json": [
		"fed9",
		"chunk-2d23864a"
	],
	"./happiness/ru.json": [
		"8b62",
		"chunk-2d0e8c5c"
	],
	"./happiness/uz-to.json": [
		"3231",
		"chunk-2d0b91f3"
	],
	"./happiness/uz.json": [
		"f593",
		"chunk-2d22ccdf"
	],
	"./oil/en.json": [
		"9be1",
		"chunk-2d0f066b"
	],
	"./oil/ru.json": [
		"d4a9",
		"chunk-2d21e53e"
	],
	"./oil/uz-to.json": [
		"1c73",
		"chunk-2d0b61a4"
	],
	"./oil/uz.json": [
		"0f86",
		"chunk-2d0af8aa"
	],
	"./population/en.json": [
		"7799",
		"chunk-2d0d76f6"
	],
	"./population/ru.json": [
		"4905",
		"chunk-2d0c2040"
	],
	"./population/uz-to.json": [
		"c4ea",
		"chunk-2d217183"
	],
	"./population/uz.json": [
		"9de5",
		"chunk-2d0f0df1"
	],
	"./power/en.json": [
		"66f8",
		"chunk-2d0d0448"
	],
	"./power/ru.json": [
		"c0d6",
		"chunk-2d216235"
	],
	"./power/uz-to.json": [
		"f33e",
		"chunk-2d22c4d5"
	],
	"./power/uz.json": [
		"d5b6",
		"chunk-2d21e91b"
	],
	"./production/en.json": [
		"b039",
		"chunk-2d20e7ea"
	],
	"./production/ru.json": [
		"b6ab",
		"chunk-2d21042b"
	],
	"./production/uz-to.json": [
		"5c13",
		"chunk-2d0d3266"
	],
	"./production/uz.json": [
		"cb78",
		"chunk-2d221876"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "c4ff";
module.exports = webpackAsyncContext;